// @systeme: interface
import { useState, type FormEvent } from 'react';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { Link as LienRouteur } from 'react-router';
import { FormulaireAuth } from '../composants/FormulaireAuth';
import { messageDe } from '../composants/Messages';
import { api } from '../lib/api';

export function MotDePasseOublie() {
  const [email, setEmail] = useState('');
  const [erreur, setErreur] = useState<string | undefined>();
  const [envoye, setEnvoye] = useState(false);
  const [enCours, setEnCours] = useState(false);

  async function soumettre(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setErreur(undefined);
    setEnCours(true);
    try {
      await api.auth.motDePasseOublie({ email });
      setEnvoye(true);
    } catch (err) {
      setErreur(messageDe(err));
    } finally {
      setEnCours(false);
    }
  }

  return (
    <FormulaireAuth
      titre="Nouveau mot de passe"
      sousTitre="Donne-nous ton adresse : tu recevras un lien pour en choisir un autre."
      erreur={erreur}
      onSoumettre={soumettre}
      pied={
        <Link component={LienRouteur} to="/connexion">
          Retour à la connexion
        </Link>
      }
    >
      {envoye ? (
        <Typography>
          Si un compte existe avec cette adresse, un lien vient de partir. Regarde aussi les
          indésirables.
        </Typography>
      ) : (
        <>
          <TextField
            label="Ton adresse courriel"
            type="email"
            autoComplete="email"
            inputMode="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <Button type="submit" variant="contained" size="large" disabled={enCours}>
            Envoyer le lien
          </Button>
        </>
      )}
    </FormulaireAuth>
  );
}
